:root {
  view-transition-name: none;
}

::view-transition {
  pointer-events: none;
}

body {
  max-width: 40rem;
  margin: auto;
  padding-top: var(--inset-top);
}

.iconButton {
  composes: iconButton from "../chrome.module.css";
}

.srOnly {
  composes: srOnly from "../chrome.module.css";
}

.tile {
  composes: tile faceUp from "../tile.module.css";
  --tile-size: 2rem;
}

.header {
  display: flex;
  justify-content: space-between;
  max-width: 18rem;
  margin: 1rem auto;
}

.looseLetters {
  position: relative;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.3rem;
  max-width: 18rem;
  margin: auto;
  --big: min(4rem, 21vw);

  > span {
    width: var(--big);
    height: var(--big);
  }
  > .tile {
    --tile-size: var(--big);

    @media (hover: hover) {
      &:hover {
        filter: brightness(1.2);
      }
    }
  }

  .openSubmit {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    translate: -50% -50%;
    width: 3rem;
    height: 3rem;
    transition: opacity 0.5s;
    view-transition-name: open-submit;

    @starting-style {
      opacity: 0;
    }
  }
}

.pendingWord {
  margin: 2rem 1rem;
  height: 2.2rem;
  display: flex;
  justify-content: space-between;

  > .pendingLetters {
    all: unset;
    outline: revert;
    outline-offset: 2.5px;
    display: flex;
    gap: 0.1rem;
    overflow-x: scroll;
    scrollbar-width: none;

    > * {
      animation: global(pop) 0.15s;
    }

    @media (hover: hover) {
      &:hover {
        > span {
          filter: brightness(1.2);
        }
      }
    }
  }

  .incorrectGuess {
    animation: global(shake) 0.5s;
  }
}

.actions {
  display: flex;
  gap: 0.5rem;
  > button {
    animation: grow 0.1s;
  }
}

.words {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;

  > button {
    all: unset;
    outline: revert;
    outline-offset: 2.5px;
    width: fit-content;
    display: flex;
    gap: 0.1rem;

    @media (hover: hover) {
      &:hover {
        > span {
          filter: brightness(1.2);
        }
      }
    }
  }
}

.stat {
  composes: stat from "../chrome.module.css";
}

.caption {
  margin: 0 0 1.25rem;
  text-align: center;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.6;
}

@keyframes grow {
  from {
    scale: 0.5;
    opacity: 0;
  }
}
